export const fontsTgico = [
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/tgico.ttf",
      },
    ],
    weight: "normal",
  },
];
